// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"5f7c47e1","981":"00045ef5"}[chunkId] + ".chunk.js";
};